import Vue from 'vue'
export default Vue.extend({
  props: {
    value: {
      type: [Array, String],
      required: false,
      default: () => []
    },
    styles: {
      type: [Object, String],
      required: false,
      default: () => ({})
    },
    classes: {
      type: [Array, String],
      required: false,
      default: () => []
    },
    containerClasses: {
      type: [Array, String],
      required: false,
      default: () => []
    }
  },
  computed: {
    previewMode() {
      return this.$store.state.previewMode
    },
  },
})
